<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                提倡使用环保塑料袋（视频）
            </div>
            <div class="content">
                <img src="../../assets/images/mpeg.png" />
                <div class="videoView">
                    <video src="../../assets/video/tichangsu.mp4" controls muted="true" poster="../../assets/video/tichagnsu-poster.jpg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WhatIsGreenhouseIndexView",
        data() {
            return {
                index: 1
            }
        },
        methods: {
            onIndexChanged(retIndex) {
                this.index = retIndex
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 40px;
                .videoView {
                    video {
                        width: 80%;
                        margin-left: 10%;
                    }
                    width: 100%;
                }
                img {
                    height: 60px;
                    margin-bottom: 30px;
                }
            }

        }
    }
</style>